import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import { useChangeLeadStatusStore } from '../..';
import useAddLeadNoteValidationSchema from '../../hooks/useAddLeadNoteValidationSchema';
import { useConditionallyClosable } from '../../hooks/useClosable';
import { ClosableOrder } from '../../store/ClosableStore';
import { leadStatusToString } from '../../utils/enumUtils';
import commonStyles from "../Common.module.css";
import editStyles from "../Edit.module.css";
import TextInput from '../inputs/TextInput';
import Modal from "../Modal";
import Spinner from "../spinners/Spinner";

function ChangeLeadStatus() {
    const changeLeadStatusStore = useChangeLeadStatusStore();
    const validationSchema = useAddLeadNoteValidationSchema();

    const formik = useFormik<IChangeLeadStatusState>({
        initialValues: ChangeLeadStatusState.empty(),
        validationSchema: toFormikValidationSchema(validationSchema),
        onSubmit: (values) => changeLeadStatusStore.changeStatus(values.text!),
    });

    const cancel = () => {
        if (!formik.isSubmitting)
            changeLeadStatusStore.close();
    };

    useConditionallyClosable(ClosableOrder.High, cancel, changeLeadStatusStore.isOpen());

    useEffect(() => {
        if (changeLeadStatusStore.isOpen())
            formik.resetForm({ values: ChangeLeadStatusState.empty() });
    }, [changeLeadStatusStore.isOpen()]);

    if (!changeLeadStatusStore.isOpen())
        return null;

    return (
        <Modal midWidth header={`Change Status to ${leadStatusToString(changeLeadStatusStore.status!)}`} onClose={cancel}>
            <div className={editStyles.column}>
                <TextInput formik={formik} label="NOTE" name="text" placeholder="Enter note..." />
                <div className={commonStyles.controlGroup}>
                    <button className={commonStyles.secondaryButton} disabled={formik.isSubmitting} onClick={cancel}>Cancel</button>
                    {formik.isSubmitting ? (
                        <Spinner />
                    ) : (
                        <button type="submit" className={commonStyles.primaryButton} onClick={() => formik.handleSubmit()}>Change Status</button>
                    )}
                </div>
            </div>
        </Modal>
    );
}

export default observer(ChangeLeadStatus);

interface IChangeLeadStatusState {
    text: string | null;
}

class ChangeLeadStatusState implements IChangeLeadStatusState {
    text: string | null = null;

    static empty() {
        return new ChangeLeadStatusState();
    }
}
